import React, {FC, useState} from 'react';
import FormPanel from '../../../components/FormPanel';
import ensureCsrfCookie from '../../../utils/ensureCsrfCookie';
import GradientHeading from '../components/GradientHeading';
import Page from '../components/Page';
import {Box, Button, Center, chakra, Checkbox, FormControl} from 'components/ui/chakra';
import RegisterController from 'puddleglum/api/auth/RegisterController';

const AcceptTerms: FC = () => {
	const [acceptTerms, setAcceptTerms] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const handleAcceptTerms = async () => {
		setIsSaving(true);
		try {
			await ensureCsrfCookie();
			// Since SMS consent is embedded in the terms, we always set it to true when terms are accepted
			await RegisterController.acceptTerms({
				sms_consent: true,
			});
		} catch (error) {
			console.error('Failed to accept terms:', error);
		} finally {
			window.location.href = '/';
		}
	};

	return (
		<Page overflow='auto'>
			<Center w='100%' p={{base: 'none', sm: 8}}>
				<FormPanel
					minH={{base: '100vh', sm: 'auto'}}
					w={{base: '100%', sm: '60%', lg: '50%'}}
					description='Review the terms and consent language before entering the application.'
				>
					<GradientHeading my={4}>Please review our terms of service.</GradientHeading>

					{/* Terms iframe */}
					<Box
						my={6}
						borderRadius='md'
						overflow='hidden'
						border='1px solid'
						borderColor='border'
						height='400px'
						width='100%'
					>
						<iframe
							src='/terms'
							width='100%'
							height='100%'
							style={{border: 'none'}}
							title='Terms of Service'
						/>
					</Box>

					<FormControl my={8}>
						<Checkbox
							size='lg'
							colorPalette='blue'
							isChecked={acceptTerms}
							onChange={(e) => setAcceptTerms(e.target.checked)}
							borderColor='border'
						>
							I consent to the above terms of service and to the{' '}
							<chakra.a
								href='https://www.calvient.com/privacy-policy'
								target='_blank'
								textDecoration='underline'
								color='blue.600'
							>
								privacy policy
							</chakra.a>
							.
						</Checkbox>
					</FormControl>

					<Button
						w='full'
						colorScheme='blue'
						onClick={handleAcceptTerms}
						isLoading={isSaving}
						isDisabled={!acceptTerms}
					>
						Take Me to Allora
					</Button>
				</FormPanel>
			</Center>
		</Page>
	);
};
export default AcceptTerms;
